import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './RightToInfo.css';

const RightToInfo = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['माहितीचा अधिकार', 'RTI', 'अर्ज', 'माहिती'],
    en: ['right to information', 'RTI', 'application', 'information']
  });

  const pageHeaderData = {
    title: {
      marathi: 'माहितीचा अधिकार',
      english: 'Right to Information'
    },
    subtitle: {
      marathi: 'माहितीचा अधिकार कायदा २००५ अंतर्गत माहिती',
      english: 'Information under Right to Information Act 2005'
    }
  };

  const content = {
    marathi: {
      mainTitle: 'माहितीचा अधिकार अधिनियम २००५ नुसार नियुक्त जनमाहिती अधिकारी / प्रथम अपिलिय अधिकारी',
      description: 'महाराष्ट्र कामगार कल्याण मंडळाच्या मध्यवर्ती कार्यालय तसेच ७ विभागीय कार्यालये येथे कार्यक्षेत्रानुसार जनमाहिती अधिकारी, प्रथम अपिलिय अधिकारी यांची नियुक्ती करण्यात आली आहे. माहितीचा अधिकार अधिनियम २००५ मधील कलम ४ (ख) १६ नुसार सदर माहिती प्रसिद्ध करण्यात येत आहे.',
      lastUpdated: 'शेवटचे अपडेट: 16 सप्टेंबर 2025',
      officers: [
        {
          srNo: '१',
          jurisdiction: 'मध्यवर्ती कार्यालय, मुंबई',
          address: 'महाराष्ट्र कामगार कल्याण मंडळ\nप्रशासकीय इमारत, हुतात्मा बाबू गेनू\nमुंबई गिरणी कामगार क्रीडा भवन,\nसेनापती बापट मार्ग, एलफिन्स्टन,\nमुंबई ४०० ०१३',
          designation: 'प्रसिद्धी व विधी अधिकारी तथा जनमाहिती अधिकारी',
          phone: '०२२ – ४३२२६८१७'
        },
        {
          srNo: '',
          jurisdiction: 'वरील प्रमाणे',
          address: 'वरील प्रमाणे',
          designation: 'लेखा व लेखा परीक्षा अधिकारी तथा प्रथम अपिलिय अधिकारी',
          phone: '०२२ – ४३२२६८१४'
        },
        {
          srNo: '२',
          jurisdiction: 'विभागीय कार्यालय, मुंबई',
          address: 'ललित कला भवन,\nअपना बजार मागे,\nगोविंदजी केणी मार्ग,\nनायगाव, मुंबई – ४०००१२',
          designation: 'सहायक लेखा अधिकारी तथा जनमाहिती अधिकारी',
          phone: '०२२ - २४१२१३२५'
        },
        {
          srNo: '',
          jurisdiction: 'वरील प्रमाणे',
          address: 'वरील प्रमाणे',
          designation: 'सहायक कल्याण आयुक्त तथा प्रथम अपिलिय अधिकारी',
          phone: '०२२ – २४१२१३२५'
        },
        {
          srNo: '३',
          jurisdiction: 'विभागीय कार्यालय, ठाणे',
          address: 'विभागीय कार्यालय,\nठाणे कामगार कल्याण भवन,\nकन्नमवार नगर क्र.२,\nविक्रोळी पूर्व, मुंबई – ४०० ०८३',
          designation: 'सहायक लेखा अधिकारी तथा जनमाहिती अधिकारी',
          phone: '०२२ – २५७७६७५१'
        },
        {
          srNo: '',
          jurisdiction: 'वरील प्रमाणे',
          address: 'वरील प्रमाणे',
          designation: 'सहायक कल्याण आयुक्त तथा प्रथम अपिलिय अधिकारी',
          phone: '०२२ – २५७७६७५१'
        },
        {
          srNo: '४',
          jurisdiction: 'विभागीय कार्यालय, पुणे',
          address: 'विभागीय कार्यालय, पुणे\nललित कला भवन, सहकार नगर क्र.१,\nअरण्येश्वर मंदिराजवळ, पुणे – ४११००९',
          designation: 'सहायक लेखा अधिकारी तथा जनमाहिती अधिकारी',
          phone: '०२० – २४२२८९८८'
        },
        {
          srNo: '',
          jurisdiction: 'वरील प्रमाणे',
          address: 'वरील प्रमाणे',
          designation: 'प्र.सहायक कल्याण आयुक्त तथा प्रथम अपिलिय अधिकारी',
          phone: '०२० – २४२२८९८८'
        },
        {
          srNo: '५',
          jurisdiction: 'विभागीय कार्यालय, नाशिक',
          address: 'विभागीय कार्यालय, नाशिक\nकामगार कल्याण भवन,\n५१७, महाराष्ट्र हाऊसिंग बोर्ड कॉलनी,\nसातपूर रोड, नाशिक',
          designation: 'सहायक लेखा अधिकारी तथा जनमाहिती अधिकारी',
          phone: '०२५३ – २३५११६०'
        },
        {
          srNo: '',
          jurisdiction: 'वरील प्रमाणे',
          address: 'वरील प्रमाणे',
          designation: 'प्र.सहायक कल्याण आयुक्त तथा प्रथम अपिलिय अधिकारी',
          phone: '०२५३ – २३५११६०'
        },
        {
          srNo: '६',
          jurisdiction: 'विभागीय कार्यालय, औरंगाबाद',
          address: 'विभागीय कार्यालय, औरंगाबाद\nललित कला भवन, उस्मानपुरा,\nऔरंगाबाद, ४३१००५',
          designation: 'सहायक लेखा अधिकारी तथा जनमाहिती अधिकारी',
          phone: '०२४० – २३३१५४६'
        },
        {
          srNo: '',
          jurisdiction: 'वरील प्रमाणे',
          address: 'वरील प्रमाणे',
          designation: 'प्र.सहायक कल्याण आयुक्त तथा प्रथम अपिलिय अधिकारी',
          phone: '०२४० – २३३१५४६'
        },
        {
          srNo: '७',
          jurisdiction: 'विभागीय कार्यालय, नागपूर',
          address: 'विभागीय कार्यालय, नागपूर\nकामगार कल्याण भवन,\nराजे रघुजीनगर,\nनागपूर - ४४०००१',
          designation: 'सहायक लेखा अधिकारी तथा जनमाहिती अधिकारी',
          phone: '०७१२- २७४९६४७'
        },
        {
          srNo: '',
          jurisdiction: 'वरील प्रमाणे',
          address: 'वरील प्रमाणे',
          designation: 'सहायक कल्याण आयुक्त तथा प्रथम अपिलिय अधिकारी',
          phone: '०७१२- २७४९६४७'
        },
        {
          srNo: '८',
          jurisdiction: 'विभागीय कार्यालय, अकोला',
          address: 'विभागीय कार्यालय, अकोला\nललित कला भवन,\nकस्तुरबा हॉस्पिटलजवळ,\nभीमनगर, अकोला',
          designation: 'सहायक लेखा अधिकारी तथा जनमाहिती अधिकारी',
          phone: '०७२४ – २४३३२७५'
        },
        {
          srNo: '',
          jurisdiction: 'वरील प्रमाणे',
          address: 'वरील प्रमाणे',
          designation: 'प्र.सहायक कल्याण आयुक्त तथा प्रथम अपिलिय अधिकारी',
          phone: '०७२४ – २४३३२७५'
        }
      ]
    },
    english: {
      mainTitle: 'Public Information Officer / First Appellate Officer appointed under Right to Information Act 2005',
      description: 'Public Information Officers and First Appellate Officers have been appointed at the Central Office of Maharashtra Labour Welfare Board and 7 Divisional Offices according to their jurisdiction. This information is being published as per Section 4(b)16 of the Right to Information Act 2005.',
      lastUpdated: 'Last Updated: September 16, 2025',
      officers: [
        {
          srNo: '1',
          jurisdiction: 'Central Office, Mumbai',
          address: 'Maharashtra Labour Welfare Board\nAdministrative Building, Hutatma Babu Genu\nMumbai Mill Workers Sports Building,\nSenapati Bapat Marg, Elphinstone,\nMumbai 400 013',
          designation: 'Publicity and Legal Officer and Public Information Officer',
          phone: '022 – 43226817'
        },
        {
          srNo: '',
          jurisdiction: 'As above',
          address: 'As above',
          designation: 'Accounts & Audit Officer & First Appellate Officer',
          phone: '022 – 43226814'
        },
        {
          srNo: '2',
          jurisdiction: 'Divisional Office, Mumbai',
          address: 'Lalit Kala Bhavan,\nBehind Apna Bazar,\nGovindji Keni Marg,\nNaigaon, Mumbai – 400012',
          designation: 'Assistant Accounts Officer & Public Information Officer',
          phone: '022 - 24121325'
        },
        {
          srNo: '',
          jurisdiction: 'As above',
          address: 'As above',
          designation: 'Assistant Welfare Commissioner & First Appellate Officer',
          phone: '022 – 24121325'
        },
        {
          srNo: '3',
          jurisdiction: 'Divisional Office, Thane',
          address: 'Divisional Office,\nThane Labour Welfare Building,\nKannamwar Nagar No.2,\nVikhroli East, Mumbai – 400 083',
          designation: 'Assistant Accounts Officer & Public Information Officer',
          phone: '022 – 25776751'
        },
        {
          srNo: '',
          jurisdiction: 'As above',
          address: 'As above',
          designation: 'Assistant Welfare Commissioner & First Appellate Officer',
          phone: '022 – 25776751'
        },
        {
          srNo: '4',
          jurisdiction: 'Divisional Office, Pune',
          address: 'Divisional Office, Pune\nLalit Kala Bhavan, Sahakar Nagar No.1,\nNear Aryaneshwar Temple, Pune – 411009',
          designation: 'Assistant Accounts Officer & Public Information Officer',
          phone: '020 – 24228988'
        },
        {
          srNo: '',
          jurisdiction: 'As above',
          address: 'As above',
          designation: 'Deputy Assistant Welfare Commissioner & First Appellate Officer',
          phone: '020 – 24228988'
        },
        {
          srNo: '5',
          jurisdiction: 'Divisional Office, Nashik',
          address: 'Divisional Office, Nashik\nLabour Welfare Building,\n517, Maharashtra Housing Board Colony,\nSatpur Road, Nashik',
          designation: 'Assistant Accounts Officer & Public Information Officer',
          phone: '0253 – 2351160'
        },
        {
          srNo: '',
          jurisdiction: 'As above',
          address: 'As above',
          designation: 'Deputy Assistant Welfare Commissioner & First Appellate Officer',
          phone: '0253 – 2351160'
        },
        {
          srNo: '6',
          jurisdiction: 'Divisional Office, Aurangabad',
          address: 'Divisional Office, Aurangabad\nLalit Kala Bhavan, Usmanpura,\nAurangabad, 431005',
          designation: 'Assistant Accounts Officer & Public Information Officer',
          phone: '0240 – 2331546'
        },
        {
          srNo: '',
          jurisdiction: 'As above',
          address: 'As above',
          designation: 'Deputy Assistant Welfare Commissioner & First Appellate Officer',
          phone: '0240 – 2331546'
        },
        {
          srNo: '7',
          jurisdiction: 'Divisional Office, Nagpur',
          address: 'Divisional Office, Nagpur\nLabour Welfare Building,\nRaje Raghujinagar,\nNagpur - 440001',
          designation: 'Assistant Accounts Officer & Public Information Officer',
          phone: '0712- 2749647'
        },
        {
          srNo: '',
          jurisdiction: 'As above',
          address: 'As above',
          designation: 'Assistant Welfare Commissioner & First Appellate Officer',
          phone: '0712- 2749647'
        },
        {
          srNo: '8',
          jurisdiction: 'Divisional Office, Akola',
          address: 'Divisional Office, Akola\nLalit Kala Bhavan,\nNear Kasturba Hospital,\nBhimnagar, Akola',
          designation: 'Assistant Accounts Officer & Public Information Officer',
          phone: '0724 – 2433275'
        },
        {
          srNo: '',
          jurisdiction: 'As above',
          address: 'As above',
          designation: 'Deputy Assistant Welfare Commissioner & First Appellate Officer',
          phone: '0724 – 2433275'
        }
      ]
    }
  };

  const currentContent = isMarathi() ? content.marathi : content.english;

  // Helper function to sanitize phone numbers for tel: links
  // Removes all non-digit characters except + sign
  const sanitizePhoneForTel = (phone) => {
    if (!phone) return '';
    return phone.replace(/[^\d+]/g, '');
  };

  return (
    <div className="right-to-info-page">
      <div className="right-to-info-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        {/* Last Updated */}
        <p className="right-to-info-last-updated">
          {currentContent.lastUpdated}
        </p>

        <div className="right-to-info-content" data-read-section="right-to-info-content">
          <h2 className="right-to-info-main-title">
            {currentContent.mainTitle}
            </h2>
          
          <p className="right-to-info-description">
            {currentContent.description}
          </p>

          <div className="officers-table-container">
            <table className="officers-table">
              <thead>
                <tr>
                  <th>{isMarathi() ? 'अ. क्र.' : 'Sr. No.'}</th>
                  <th>{isMarathi() ? 'कार्यक्षेत्र' : 'Jurisdiction'}</th>
                  <th>{isMarathi() ? 'पत्ता' : 'Address'}</th>
                  <th>{isMarathi() ? 'पदनाम' : 'Designation'}</th>
                  <th>{isMarathi() ? 'दूरध्वनी क्रमांक' : 'Phone Number'}</th>
                </tr>
              </thead>
              <tbody>
                {currentContent.officers.map((officer, index) => (
                  <tr key={index}>
                    <td className="sr-no">{officer.srNo}</td>
                    <td className="jurisdiction">{officer.jurisdiction}</td>
                    <td className="address">
                      <pre>{officer.address}</pre>
                    </td>
                    <td className="designation">{officer.designation}</td>
                    <td className="phone">
                      <a href={`tel:${sanitizePhoneForTel(officer.phone)}`} className="phone-link">
                        {officer.phone}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
        </div>
      </div>
    </div>
  );
};

export default RightToInfo;
